import snakeCase from 'lodash/snakeCase';
import type {Config} from '../types';

export const getConfigValue = <Key extends keyof Config>(key: Key): Config[Key] => {
  const configValue = window.config[key];

  if (import.meta.env.VITE_USE_CONFIG === 'true') {
    return configValue;
  } else {
    const envValue = import.meta.env[`VITE_${snakeCase(key).toUpperCase()}`];
    if (typeof configValue === 'boolean') {
      return (envValue === 'true') as typeof configValue;
    }
    return `${envValue}` as typeof configValue;
  }
};
